import { Link, useSearchParams } from 'react-router';
import { Alert, Card, PageHeader, Spinner } from '../../components/ui';
import { ErrorPanel } from '../../components/ErrorPanel';
import { t } from '../../lib/i18n';
import { useCan } from '../../lib/session';
import { useModuleOn } from '../people/api';
import { useConnections } from './api';
import { ConnectionsCard } from './ConnectionsCard';
import { EntraCard } from './EntraCard';

const LINK = 'inline-flex min-h-10 items-center rounded-md border border-slate-300 bg-white px-3.5 text-sm font-medium hover:bg-slate-50 sm:min-h-9';

/** /manage/integrations: Slack, Microsoft Teams and Microsoft 365 (the server checks every call). */
export function IntegrationsPage() {
  const [params] = useSearchParams();
  const canManage = useCan('integrations.manage');
  const canOmp = useCan('omp_link.view') && useModuleOn('omp-link');
  const canClients = useCan('api_clients.view');
  const conns = useConnections();
  return (
    <div className="space-y-6">
      <PageHeader title={t('p4w27.int.title')} description={t('p4w27.int.description')} />
      {params.get('connected') === '1' ? <Alert kind="success">{t('p4w27.m365.justConnected')}</Alert> : null}
      {conns.isError ? <ErrorPanel error={conns.error} onRetry={() => void conns.refetch()} /> : null}
      {!conns.data && !conns.isError ? <Spinner /> : null}
      {conns.data ? (
        <>
          <ConnectionsCard kind="slack" connections={conns.data.filter((c) => c.kind === 'slack')} canManage={canManage} />
          <ConnectionsCard kind="teams" connections={conns.data.filter((c) => c.kind === 'teams')} canManage={canManage} />
        </>
      ) : null}
      <EntraCard canManage={canManage} />
      {canOmp || canClients ? (
        <Card title={t('p4w27.int.otherLinks')}>
          <div className="flex flex-wrap gap-2">
            {canOmp ? (
              <Link to="/manage/integrations/omp" className={LINK}>
                {t('p4w27.int.linkOmp')}
              </Link>
            ) : null}
            {canClients ? (
              <Link to="/manage/api-clients" className={LINK}>
                {t('p4w27.int.linkClients')}
              </Link>
            ) : null}
          </div>
        </Card>
      ) : null}
    </div>
  );
}
